import React from 'react'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const StyledExpansionPanel = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        "&::before": {
            content: 'none',
        },
    },
})(ExpansionPanel)

const StyledExpansionPanelSummary = withStyles((theme) => ({
    root: {
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: theme.spacing.unit * 2,
        minHeight: 0,
        '&$expanded': {
            minHeight: 0,
        },
    },
    expanded: {
        marginTop: theme.spacing.unit * 2,
    },
    expandIcon: {
        top: theme.spacing.unit * 1.5,
        right: theme.spacing.unit * -1,
        margin: 0,
    },
    content: {
        margin: 0,
        '&$expanded': {
            margin: 0,
        },
    },
}))(ExpansionPanelSummary)

const StyledExpansionPanelDetails = withStyles((theme) => ({
    root: {
        padding: '8px 0',
        "& li": {
            marginTop: theme.spacing.unit,
            marginBottom: theme.spacing.unit ,
        },
        "& ul": {
            paddingLeft: theme.spacing.unit * 3,
        },
    },
}))(ExpansionPanelDetails)

export default ({ title, children }) => (
    <StyledExpansionPanel>
        <StyledExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body1">
                {title}
            </Typography>
        </StyledExpansionPanelSummary>
        <StyledExpansionPanelDetails>
            <Typography variant="body1" component="div">
                <ul>
                    {children}
                </ul>
            </Typography>
        </StyledExpansionPanelDetails>
    </StyledExpansionPanel>
)



// WEBPACK FOOTER //
// ./src/components/Help/Question.js